import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { DatePicker } from '../../search-module/components/date-time/mobile/mobile-date-picker';
import { SubTray } from '../sub-tray';

export const DateTray = (props) => {
  return (
    <SubTray
      trayTitle={
        <FormattedMessage
          id='shared_component.mobile-date-time-picker.date'
          defaultMessage='Date'
        />
      }
      {...props}
    >
      <DatePicker
        value={props.dateValue}
        setValue={(val) => {
          props.setActiveTray('main');
          props.setDateValue(val);
        }}
        getMonthAvailability={props.getMonthAvailability}
        monthAvailability={props.monthAvailability}
        monthAvailabilityLoading={props.monthAvailabilityLoading}
      />
    </SubTray>
  );
};

DateTray.propTypes = {
  dateValue: PropTypes.instanceOf(Date),
  setActiveTray: PropTypes.func,
  setDateValue: PropTypes.func,
  getMonthAvailability: PropTypes.func,
  monthAvailability: PropTypes.array,
  monthAvailabilityLoading: PropTypes.bool
};
